/** Settings > Connected apps. */
export const CONNECTED_APPS_PATH = '/admin/settings/connected-apps';
/** Where an app's authorize request lands the browser (the backend redirects here after it validates the request). */
export const CONSENT_PATH = '/oauth/consent';
